import { CSSProperties, FC } from 'react';

interface Props {
  showDesc?: boolean;
  style?: CSSProperties;
}

const AppAdvantage: FC<Props> = ({ showDesc = false, style }) => {
  const advantageList = [
    {
      name: '看模',
      desc: '无缝兼容多种主流BIM、CAD、GIS和3D模型格式高效的云端轻量化处理，浏览器、桌面端、移动端秒级加载与浏览。完整的模型属性查询、多模型多图层集成展示、多视图切换、大规模模型及长线路项目的流畅浏览，以及精细BIM模型显示、多维度剖切分析、精准路线资料检索等功能。',
      logo: require('@images/home/advantage/01.png').default,
    },
    {
      name: '组模',
      desc: '灵活组装不同来源、不同格式的模型。利用拖拽插入、放置等直观操作，在同一场景中进行模型整合。结合云端和本地构件库资源，用户能够方便快捷地对模型进行位置调整、部件插入、删除和替换，从而适应各种复杂工程需求。',
      logo: require('@images/home/advantage/02.png').default,
    },
    {
      name: '秀模',
      desc: '提供炫酷的漫游动画制作、项目看板展示H5+BIM+GIS一体化汇报等功能，让用户能够生动、准确地展示项目成果，不仅满足日常的项目进度汇报需求，还能实现数字化交付和交互式项目汇报演示。',
      logo: require('@images/home/advantage/03.png').default,
    },
    {
      name: '转模',
      desc: '强大的格式互转能力，支持BIM模型从DGN、RVT、SKP、FBX等多种格式组装后导出DGN格式，也可以导出为GIS或游戏软件需要的文件格式，确保模型数据在不同项目阶段和合作方之间顺畅流转。',
      logo: require('@images/home/advantage/04.png').default,
    },
  ];

  const advantageListJSX = advantageList.map((item) => {
    return (
      <div className={'item advantage'} key={item.name}>
        <img src={item.logo} alt="" />
        <span className={'name'}>{item.name}</span>
        {showDesc ? <span className={'desc'}>{item.desc}</span> : null}
      </div>
    );
  });

  return (
    <div className={'app-advantage detail-desc'} style={style}>
      <div className={'content-title'}>
        <span className={'text'}>核心优势</span>
        <span className={'line'} />
      </div>
      <div className={'content'} style={{fontSize:'14px'}}>{advantageListJSX}</div>
    </div>
  );
};

export default AppAdvantage;
